<div class="container">
  <fgb-split-transaction-history></fgb-split-transaction-history>
</div>
